const Backbone = require('backbone');
const ShoppingListSelectorModel = Backbone.Model.extend({
	urlRoot: '/app/api/projects/v2/user/dataForShoppingListSelector',
	api: 'local',
	parse: function() {
		return this.attributes;
	}
});

module.exports = ShoppingListSelectorModel;
